exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(359deg)}}@keyframes fadein{from{opacity:0}to{opacity:1}}@keyframes fadeScale{from{opacity:0;transform:scale(0)}to{opacity:1;transform:scale(1)}}@keyframes fadeRise{from{opacity:0;transform:translateY(100%)}to{opacity:1;transform:translateY(0%)}}@keyframes moveGradient{0%{transform:translateX(0%)}100%{transform:translateX(75%)}}@keyframes fadeGrow{from{transform-origin:top center;opacity:0;transform:scaleY(0)}to{transform-origin:top center;opacity:1;transform:scaleY(1)}}@keyframes growRight{from{transform-origin:top left;transform:scaleX(0)}to{transform-origin:top left;transform:scaleX(1)}}@keyframes fadeFall{from{opacity:0;transform:translateY(-100%)}to{opacity:1;transform:translateY(0%)}}@keyframes pulse{0%{opacity:0;transform:scale(0.8)}100%{opacity:1;transform:scale(1)}}@keyframes badge-in{0%{opacity:0;transform:translateY(80px)}50%{opacity:1;transform:translateY(0)}}.public-health-badge-component{background:#fff;color:#333;text-align:center;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.public-health-badge-component .animation-fade-in{animation-name:fadein;animation-iteration-count:1;animation-fill-mode:both;animation-duration:.3s;animation-delay:.3s}.public-health-badge-component header{background-color:#f2f2f2;background-color:#049fda;color:#fff;padding:40px 20px}.public-health-badge-component header.status-unknown{background-color:#ea3030}.public-health-badge-component header.status-not-verified{background-color:#cf4845}.public-health-badge-component header figure{position:relative;display:flex;border-radius:50%;height:200px;width:200px;margin:30px auto;animation-name:badge-in;animation-iteration-count:1;animation-duration:1s;animation-delay:.3s;animation-fill-mode:both;max-height:25vh;max-width:25vh}.public-health-badge-component header figure svg{margin:auto;height:80%;width:80%;color:#fff}.public-health-badge-component header figure:before{content:\"\";z-index:-1;border-radius:50%;position:absolute;box-shadow:0px 0px 0px 10px rgba(0,0,0,.1);width:100%;height:100%;animation-name:pulse;animation-direction:alternate;animation-iteration-count:infinite;animation-duration:1s;animation-delay:.3s}.public-health-badge-component header h4.phb-timestamp{margin-bottom:.3em}.public-health-badge-component section{padding:40px 20px;color:#828282}.public-health-badge-component section strong,.public-health-badge-component section span{display:block}", ""]);

// Exports
exports.locals = {
	"colorTeal": "#54c2b6",
	"colorViolet": "#727cf5",
	"colorTealRedChannel": "84",
	"colorTealGreenChannel": "194",
	"colorTealBlueChannel": "182",
	"colorTealDark": "#26a995",
	"colorTeal50": "rgba(84,194,182,.5)",
	"colorTealScreened": "#54c2b6",
	"colorWhiteOff": "#f2f2f2",
	"colorWhite": "#fff",
	"colorWhiteTrans": "rgba(255,255,255,0)",
	"colorWhite50": "rgba(255,255,255,.5)",
	"colorWarning": "#ea3030",
	"colorWarningLight": "rgba(234,48,48,.15)",
	"colorBlack": "#333",
	"colorGrayDark": "#4f4f4f",
	"colorGray": "#828282",
	"colorGrayLight": "#e0e0e0",
	"colorGrayLight60": "rgba(224,224,224,.6)",
	"colorBlue": "#049fda",
	"colorBlackDark": "#242424",
	"ColorText": "#474747",
	"colorBlueScreened": "#049fda",
	"colorMagenta": "#ea3b7d",
	"colorMagentaScreened": "#ea3b7d",
	"colorYellow": "#fed504",
	"colorYellowDark": "#d8b129",
	"colorYellowScreened": "#fed504",
	"colorUi1": "rgba(4,159,218,.3)",
	"colorUi2": "rgba(84,194,182,.3)",
	"colorUi3": "rgba(234,59,125,.3)",
	"colorUi4": "rgba(254,213,4,.3)",
	"colorUi5": "rgba(31,79,228,.3)",
	"colorUi6": "rgba(177,208,21,.3)",
	"colorUi7": "rgba(228,34,255,.3)",
	"colorUi8": "rgba(255,157,39,.3)",
	"colorUi9": "rgba(66,32,208,.3)",
	"colorUi10": "rgba(26,255,198,.3)",
	"colorUi11": "rgba(205,38,26,.3)",
	"colorUi12": "rgba(247,184,50,.3)",
	"colorUi13": "rgba(146,79,207,.3)",
	"colorUi14": "rgba(98,205,36,.3)",
	"colorUi15": "rgba(255,24,9,.3)",
	"colorUi16": "rgba(207,111,79,.3)",
	"chartLightYellow": "rgba(252,215,34,.7)",
	"chartLightPink": "rgba(250,92,124,.7)",
	"chartLightBlue": "rgba(57,175,209,.7)",
	"fontStyleNormal": "\"robotoregular\",sans-serif"
};